import { createSlice } from '@reduxjs/toolkit'

// Actions - used with useDispatch
export const screenSlice = createSlice({
  name: 'screen',
  initialState: {
    sidebarShow: true,
    sidebarUnfoldable: true,
  },
  reducers: {
    setSidebar: (state, action) => {
      state.sidebarShow = action.payload
    },
    toggleSidebar: (state, action) => {
      state.sidebarShow = !state.sidebarShow
    },
    toggleSidebarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
  },
})
export const { setSidebar, toggleSidebar, toggleSidebarUnfoldable } = screenSlice.actions

// Selector (Read data) - used with useSelector
export const selectSidebarShow = (state) => state.screen.sidebarShow
export const selectSidebarUnfoldable = (state) => state.screen.sidebarUnfoldable

export default screenSlice.reducer
